import { styled } from 'shared/ui';

export const Sp02Wrap = styled('div', {
  display: 'flex',
  gap: '48px',
});
